import { render, staticRenderFns } from "./DiabloDecor.vue?vue&type=template&id=7577dade&"
import script from "./DiabloDecor.vue?vue&type=script&lang=ts&"
export * from "./DiabloDecor.vue?vue&type=script&lang=ts&"
import style0 from "./DiabloDecor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports